<template>
  <div
    class="static-legend"
    :class="{
      'static-legend--sticky-bottom': fixed === 'bottom',
      'static-legend--sticky-top': fixed === 'top',
    }"
    :style="{ width: width ? `${width}px` : '100%' }"
  >
    <div
      class="legends"
      v-for="(legend, index) in items"
      :key="`legend-group--${index}`"
    >
      <p v-if="legend.itemsTitle" strong class="f-ui-2-bold">
        {{ legend.itemsTitle }}
      </p>
      <ul class="legend-items" :class="{ 'legend-items--spread': spread }">
        <li v-for="item in legend.items" :key="item.label" class="legend-item">
          <div
            class="legend-item__color"
            :class="{
              [`legend-item__color background-${item.color}`]: item.color,
              'legend-item__color--translucent': item.translucent,
            }"
          >
            <div
              v-if="item.type === 'line'"
              style="width: 2px; height: 100%"
              :class="{
                [`legend-item__line background-${item.lineColor}`]:
                  item.lineColor,
                line__horizontal: item.horizontal,
              }"
            />
          </div>
          <span class="legend-item__label f-ui-2">{{ item.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    background: {
      type: Boolean,
      required: false,
    },
    fixed: {
      type: String,
      default: null,
    },
    columns: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: null,
    },
    // Should legend items spread out or pack left?
    spread: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped>
.static-legend {
  position: relative;
  padding: 0 20px;
  display: inline-block;
  max-width: 100%;
  margin-top: 15px;
  background: #fff;
  border-top: 1px solid #e6e6e6;
}
.static-legend--sticky-bottom {
  position: absolute;
  /* bottom: 20px; */
}
.static-legend--sticky-top {
  position: absolute;
  top: 20px;
}
.legends {
  display: flex;
  flex-flow: column;
  margin: 10px 0;
}
.legend-items {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.legend-items--spread {
  justify-content: center;
}
.legend-items--columns-1 {
  display: block;
}
.legend-items--columns-2 .legend-item {
  flex: 1 0 40%;
}
.legend-items--columns-3 .legend-item {
  flex: 1 0 25%;
}
.legend-item {
  flex: 0 1 auto;
}
.line__horizontal {
  width: 100% !important;
  height: 2px !important;
  margin: 0.3rem 0 0 0 !important;
}
/* .legend-item--spread {
  flex: 1 1 auto;
} */
.legend-item__color {
  content: " ";
  width: 0.75em;
  height: 0.75em;
  position: absolute;
  margin-left: -1em;
  margin-top: 0.25em;
}
.legend-item__line {
  margin: 0 auto;
}
.legend-item__color--translucent {
  opacity: 0.5;
}
/* clear rte styles */
ul.legend-items {
  padding: 0;
  margin: 0;
}
li.legend-item {
  margin: 0.1em 1em;
  padding: 0;
  box-sizing: border-box;
}
.legend-items li::before {
  content: none !important;
}
</style>
